<div class="content-uploads" *ngFor="let item of selectFiles?.files; index as i"
    [ngClass]="{'type-b': templateSuffix !== ''}">
    <div class="content-file" *ngIf="item.name;else showBtnUpload">
        <span class="content-start">
            <span class="filename">
                {{ showNameDocument(item.name) }}
            </span>
            <span class="filesize">{{item.size}}</span>
        </span>
        <span class="content-end">
            <span class="loader-file" *ngIf="item.loader"><mat-spinner [diameter]="15"></mat-spinner></span>
            <mat-icon class="icon-error" *ngIf="errorDelete">error</mat-icon>
            <img class="iconDelete" src="./assets/img/icon_delete.svg" alt="icon_delete" (click)="deleteVoucher(item)"
                *ngIf="!item.loader && !errorDelete" />
        </span>
    </div>
    <span class="msg-error" *ngIf="errorDelete">Error al eliminar archivo, intente más tarde.</span>
    <ng-template #showBtnUpload>
        <ng-container *ngIf="checkshowBtnUpload(i)">
            <p class="small-letters red" *ngIf="item.text">
                {{item.text}}
            </p>
            <!-- START - RESOLVE FIX - REPLACE TAKE PHOTO FOR UPLOAD DOCUMENTS IN MOBILE -->
            <label class="btn-upload-file mat-flat-button">
                <input type="file" (change)="changeVoucher($event, item)" [accept]="returnFilesAcept(item)">
                <img class="icon_upload" src="./assets/img/icon_upload.svg" alt="icon_upload" /> Subir archivo
            </label>
            <span class="msg-error" *ngIf="errorMaxSize">El tamaño máximo permitido es de 12Mb.</span>
            <span class="msg-error" *ngIf="errorFileAllowed">El documento debe ser de tipo PDF</span>
            <span class="msg-error" *ngIf="errorFileUpload.error">{{ errorFileUpload.msg }}</span>


            <ng-template #showDesktop>
                <label class="btn-upload-file mat-flat-button">
                    <input type="file" (change)="changeVoucher($event, item)" [accept]="returnFilesAcept(item)">
                    <img class="icon_upload" src="./assets/img/icon_upload.svg" alt="icon_upload" /> Subir archivo
                </label>
                <span class="msg-error" *ngIf="errorMaxSize">El tamaño máximo permitido es de 12Mb.</span>
                <span class="msg-error" *ngIf="errorFileAllowed">El documento debe ser de tipo PDF</span>
                <span class="msg-error" *ngIf="errorFileUpload.error">{{ errorFileUpload.msg }}</span>
            </ng-template>
        </ng-container>
    </ng-template>
</div>